import { themr } from '@friendsofreactjs/react-css-themr';
import Loader from './Loader';

export default themr('Loader')(Loader);
